import {
  Col,
  Row,
  Typography,
  Form,
  Input,
  Checkbox,
  message,
  Select,
} from "antd";
import { getLoggedUser } from "explorer/reducers/users";
import moment from "moment";
import { RadioButton } from "radar/components";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import {
  createTeamUserPerson,
  createUserCompany,
} from "shared/service/StrmService";
import FormPessoaFisica from "./FormPessoaFisica";
import FormPessoaJuridica from "./FormPessoaJuridica";
import "./TeamRequest.scss";

const TeamRequest: React.FC<RouteComponentProps> = (props) => {
  const { history, location } = props;
  const state: any = location?.state;
  const { subscriptionName } = state || {};
  const [tipoPessoa, setTipoPessoa] = useState<string>("");
  const [checkTerms, setCheckTerms] = useState<boolean>(false);
  const { t } = useTranslation("radar");
  const [form] = Form.useForm();
  const { countryOptions } = useSelector((state: any) => state.countries);
  const dispatch = useDispatch();
  const loggedUser = useSelector((state: any) => state.users.loggedUser);
  const userName = loggedUser?.login;

  const onChangeTipoPessoa = (value: string) => {
    setTipoPessoa(value);
  };

  const onFinish = async () => {
    if (checkTerms) {
      const { birthDay, ...values } = form.getFieldsValue();
      if (tipoPessoa === "fisica") {
        await createTeamUserPerson({
          birthDate: moment(birthDay),
          ...values,
          subscriptionName,
        });
      }
      if (tipoPessoa === "juridica") {
        await createUserCompany({
          ...values,
          subscriptionName,
        });
      }
      dispatch(getLoggedUser());
      history.push("/team-request-awaiting");
    } else {
      message.warning(t("pages.TeamRequest.aceptTerms"));
    }
  };

  useEffect(() => {
    form.resetFields();
  }, [tipoPessoa, form]);

  return (
    <div className="team-admin">
      <Row justify="center">
        <Col xs={12} className="texto-centralizado">
          <Typography.Title
            style={{
              fontSize: 50,
              marginBottom: 16,
              color: "#fff",
            }}
          >
            {t("pages.TeamRequest.greet1")}
            <b className="texto-colorido"> {userName}</b>
            {t("pages.TeamRequest.greet2")}
          </Typography.Title>
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: 16 }}>
        <Col xs={12} className="texto-centralizado">
          <RadioButton
            onChange={onChangeTipoPessoa}
            options={[
              { label: t("pages.TeamRequest.fisica"), value: "fisica" },
              {
                label: t("pages.TeamRequest.juridica"),
                value: "juridica",
              },
            ]}
          />
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: 32 }}>
        <Col xs={12}>
          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            className="texto-maiusculo"
          >
            {tipoPessoa === "fisica" && <FormPessoaFisica />}
            {tipoPessoa === "juridica" && <FormPessoaJuridica />}
            <Row hidden={!tipoPessoa}>
              <Col xs={24}>
                <Row gutter={16} style={{ marginTop: 16 }}>
                  <Col xs={8}>
                    <Form.Item
                      label={t("pages.TeamRequest.country")}
                      name="country"
                      rules={[
                        {
                          required: true,
                          message: t("pages.TeamRequest.countryRequired"),
                        },
                      ]}
                    >
                      <Select
                        options={countryOptions}
                        filterOption={(input, option) =>
                          (option?.label as string)
                            .toUpperCase()
                            .includes(input.toUpperCase())
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={8}>
                    <Form.Item
                      label={t("pages.TeamRequest.cidade")}
                      name="city"
                      rules={[
                        {
                          required: true,
                          message: t("pages.TeamRequest.cityRequired"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={8}>
                    <Form.Item
                      label={t("pages.TeamRequest.estado")}
                      name="state"
                      rules={[
                        {
                          required: true,
                          message: t("pages.TeamRequest.stateRequired"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item
                      label={t("pages.TeamRequest.endereco")}
                      name="address"
                      rules={[
                        {
                          required: true,
                          message: t("pages.TeamRequest.addressRequired"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item
                      label={t("pages.TeamRequest.postalCode")}
                      name="postalCode"
                      rules={[
                        {
                          required: true,
                          message: t("pages.TeamRequest.postalCodeRequired"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row justify="center" hidden={!tipoPessoa}>
              <Col
                xs={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <button
                  style={{ margin: "32px 0" }}
                  className="border-vazado-colorido"
                  onClick={() => history.push("/radar")}
                >
                  {t("pages.TeamRequest.back")}
                </button>
              </Col>
              <Col
                xs={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <button
                  style={{ margin: "32px 0" }}
                  className="border-preenchido-colorido"
                >
                  {t("pages.TeamRequest.submit")}
                </button>
              </Col>
            </Row>
          </Form>
          <Row justify="center" hidden={!tipoPessoa}>
            <Col xs={24} style={{ textAlign: "center" }}>
              <Checkbox
                checked={checkTerms}
                onChange={(e) => setCheckTerms(e.target.checked)}
              />
              <span className="termos-de-uso">
                {t("pages.TeamRequest.declarationRead")}
                <a
                  href={`${process.env.REACT_APP_APPLICATION_URL}/terms-of-use.html`}
                  target="_blank"
                  rel="noreferrer"
                  className="texto-colorido"
                >
                  {t("pages.TeamRequest.termsOfService")}
                </a>
                {t("pages.TeamRequest.junction")}
                <a
                  href={`${process.env.REACT_APP_APPLICATION_URL}/privacy-policy.html`}
                  target="_blank"
                  rel="noreferrer"
                  className="texto-colorido"
                >
                  {t("pages.TeamRequest.privacyStatement")}
                </a>
                .
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default TeamRequest;
